import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

const ProfileDropdown = ({ onClose }) => {
  const navigate = useNavigate();
  const ref = useRef(null);

  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) onClose();
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [onClose]);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("refresh_token");
    onClose();
    window.location.href = "/login";
  };

  const go = (path) => { navigate(path); onClose(); };

  return (
    <div ref={ref} style={{
      position: "absolute", top: "48px", right: 0,
      background: "#fff", borderRadius: "14px", padding: "8px",
      boxShadow: "0 8px 32px rgba(0,0,0,0.12)", border: "1px solid #f0ebe3",
      minWidth: "180px", zIndex: 1000,
    }}>
      {[
        { icon: "👤", label: "View Profile",  action: () => go("/profile") },
        { icon: "📦", label: "My Orders",     action: () => go("/profile?tab=orders") },
      ].map(({ icon, label, action }) => (
        <button key={label} onClick={action}
          style={{ display: "flex", alignItems: "center", gap: "10px", width: "100%", padding: "10px 14px", borderRadius: "10px", border: "none", background: "transparent", cursor: "pointer", fontFamily: "Georgia, serif", fontSize: "13px", color: "#1a1a1a", textAlign: "left" }}
          onMouseEnter={e => e.currentTarget.style.background = "#faf7f2"}
          onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
          <span>{icon}</span> {label}
        </button>
      ))}

      <div style={{ margin: "6px 0", borderTop: "1px solid #f0ebe3" }} />

      <button onClick={handleLogout}
        style={{ display: "flex", alignItems: "center", gap: "10px", width: "100%", padding: "10px 14px", borderRadius: "10px", border: "none", background: "transparent", cursor: "pointer", fontFamily: "Georgia, serif", fontSize: "13px", color: "#c0392b", textAlign: "left" }}
        onMouseEnter={e => e.currentTarget.style.background = "#fff0f0"}
        onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
        🚪 Logout
      </button>
    </div>
  );
};

export default ProfileDropdown;